import { styled } from '@mui/material/styles';

import { px, rem, Theme } from '../../theme';
import { Heading } from '../Heading';

export const StyledContainer = styled('div')<{
    $noGutterBottom?: boolean;
    theme: Theme;
}>`
    ${({ theme, $noGutterBottom }) => `
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: ${$noGutterBottom ? theme.tggSpacing(0, 0) : theme.tggSpacing(px(40), 10)};

        ${theme.breakpoints.up('desktop')} {
            padding-bottom: ${$noGutterBottom ? theme.tggSpacing(0, 0) : theme.tggSpacing(px(80), 20)};
        }
	`}
`;

export const StyledParagraphSection = styled('article')`
    ${({ theme }: { theme: Theme }) => `
        margin-bottom: ${theme.tggSpacing(rem(2), 5)};
        b {
            font-family: thegymgroupsans-Headline, sans-serif;
        }
        ${theme.breakpoints.up('desktop')} {
            text-align: center;
        }
	`}
`;

export const StyledSection = styled('section')`
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        flex-direction: column;
        margin: ${theme.tggSpacing([rem(2.5), rem(2.5), 0], [6, 6, 0])};
        ${theme.breakpoints.up('desktop')} {
            align-items: center;
            max-width: ${theme.tggSpacing(rem(85), 212.5)};
            margin: ${theme.tggSpacing([rem(3), 'auto', 0], [7.5, 'auto', 0])};
        }
	`}
`;

export const StyledHeading = styled(Heading)`
    ${({ theme }: { theme: Theme }) => `
        margin-bottom: ${theme.tggSpacing(rem(1.5), 3.75)};
        ${theme.breakpoints.up('desktop')} {
            text-align: center;
        }
	`}
`;

export const StyledChildren = styled('div')<{
    $isWider: boolean;
    theme: Theme;
}>`
    ${({ theme, $isWider }) => `
        ${theme.breakpoints.up('desktop')} {
            width: ${$isWider ? theme.tggSpacing(rem(84.9), 340) : theme.tggSpacing(rem(51.5), 128.75)};
        }
	`}
`;

export const StyledImageContainer = styled('div')`
    display: flex;
    justify-content: center;
`;
